"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const mxw_libs_errors_1 = require("mxw-libs-errors");
const utils_1 = require("./utils");
const util_1 = __importDefault(require("util"));
__export(require("bignumber.js"));
var Mode;
(function (Mode) {
    Mode[Mode["safe"] = 0] = "safe";
    Mode[Mode["basic"] = 1] = "basic";
})(Mode = exports.Mode || (exports.Mode = {}));
const inspect = util_1.default.inspect.custom;
bignumber_js_1.default.config({ DECIMAL_PLACES: 80, EXPONENTIAL_AT: [-1e9, 1e9] });
function safeBigNumberify(value, config, mode = Mode.safe, base) {
    let bn;
    if (config) {
        let BN;
        if ("object" == typeof config) {
            BN = SafeBigNumber.clone(config, mode);
        }
        else {
            BN = config;
        }
        bn = new BN(value, baseValue(base));
    }
    else {
        bn = new SafeBigNumber(value, baseValue(base));
    }
    return bn;
}
exports.safeBigNumberify = safeBigNumberify;
class SafeBigNumber extends bignumber_js_1.default {
    constructor(n, base) {
        super(n, base);
        this[inspect] = safeInspect;
        this.toString = safeToString;
        this.valueOf = safeToString;
        this.toJSON = safeToJSON;
        // if (Mode.safe == configMode) {
        //     for (let func of ["plus", "minus", "multipliedBy", "dividedBy", "dividedToIntegerBy"]) {
        //         this["_" + func] = this[func];
        //     }
        //     this.plus = safePlus;
        //     this.minus = safeMinus;
        //     this.multipliedBy = this.times = safeMultipliedBy;
        //     this.dividedBy = this.div = safeDividedBy;
        //     this.dividedToIntegerBy = safeDividedToIntegerBy;
        if (this.isNaN()) {
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.NUMERIC_FAULT, "invalid number string value - " + n, { fault: "NaN", value: n });
        }
        if (!this.isFinite()) {
            mxw_libs_errors_1.errors.throwError(mxw_libs_errors_1.errors.NUMERIC_FAULT, "infinity number string value - " + n, { fault: "infinity", value: n });
        }
        // }
    }
    static config(object, mode = Mode.safe) {
        // configMode = mode;
        return super.config(object);
    }
    static clone(object, mode = Mode.safe) {
        if (!object) {
            object = {};
        }
        let c = super.clone(object);
        c.prototype["_CONFIG"] = object;
        c.prototype["_toString"] = c.prototype.toString;
        c.prototype[inspect] = safeInspect;
        c.prototype.toString = safeToString;
        c.prototype.valueOf = safeToString;
        c.prototype.toJSON = safeToJSON;
        // if (Mode.safe == mode) {
        //     for (let func of ["plus", "minus", "multipliedBy", "dividedBy", "dividedToIntegerBy"]) {
        //         c.prototype["_" + func] = c.prototype[func];
        //     }
        //     c.prototype.plus = safePlus;
        //     c.prototype.minus = safeMinus;
        //     c.prototype.multipliedBy = c.prototype.times = safeMultipliedBy;
        //     c.prototype.dividedBy = c.prototype.div = safeDividedBy;
        //     c.prototype.dividedToIntegerBy = safeDividedToIntegerBy;
        // }
        return c;
    }
}
exports.SafeBigNumber = SafeBigNumber;
let safeInspect = function (depth, options) {
    return this["_toString"](10);
};
let safeToString = function (base) {
    return this["_toString"](baseValue(base));
};
bignumber_js_1.default.prototype["_toString"] = bignumber_js_1.default.prototype.toString;
bignumber_js_1.default.prototype.toString = safeToString;
bignumber_js_1.default.prototype.valueOf = safeToString;
let safeToJSON = function () {
    return this["_toString"](10);
};
bignumber_js_1.default.prototype.toJSON = safeToJSON;
// let safePlus = function (n: BigNumber.Value, base: number = 10, mode: Mode = Mode.safe) {
//     let r = this["_plus"](n, baseValue(base));
//     if (r.gte(0, baseValue(base)) || Mode.basic == mode) {
//         return r;
//     }
//     throwError(errors.NUMERIC_FAULT, "SafeBigNumber: plus exception", { a: this, b: n, base: baseValue(base) });
// };
// let safeMinus = function (n: BigNumber.Value, base: number = 10, mode: Mode = Mode.safe) {
//     let r = this["_minus"](n, baseValue(base));
//     if (r.gte(0, baseValue(base)) || Mode.basic == mode) {
//         return r;
//     }
//     throwError(errors.NUMERIC_FAULT, "SafeBigNumber: minus exception", { a: this, b: n, base: baseValue(base) });
// };
// let safeMultipliedBy = function (n: BigNumber.Value, base: number = 10, mode: Mode = Mode.safe) {
//     let r = this["_multipliedBy"](n, baseValue(base));
//     if (r.gte(0, baseValue(base)) || Mode.basic == mode) {
//         return r;
//     }
//     throwError(errors.NUMERIC_FAULT, "SafeBigNumber: multipliedBy exception", { a: this, b: n, base: baseValue(base) });
// };
// let safeDividedBy = function (n: BigNumber.Value, base: number = 10, mode: Mode = Mode.safe) {
//     let r = this["_dividedBy"](n, baseValue(base));
//     if (r.isFinite() || Mode.basic == mode) {
//         return r;
//     }
//     throwError(errors.NUMERIC_FAULT, "SafeBigNumber: dividedBy exception", { a: this, b: n, base: baseValue(base) });
// };
// let safeDividedToIntegerBy = function (n: BigNumber.Value, base?: number, mode: Mode = Mode.safe) {
//     let r = this["_dividedToIntegerBy"](n, baseValue(base));
//     if (r.isFinite() || Mode.basic == mode) {
//         return r;
//     }
//     throwError(errors.NUMERIC_FAULT, "SafeBigNumber: dividedToIntegerBy exception", { a: this, b: n, base: baseValue(base) });
// };
function baseValue(n) {
    if (utils_1.isUndefinedOrNullOrEmpty(n)) {
        return 10;
    }
    else {
        if (0 == n) {
            return undefined;
        }
    }
    return n;
}
//# sourceMappingURL=safe-bignumber.js.map